'use strict';

module.exports = require('./is-implemented')() ? Map : require('./polyfill');



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es6-map/index.js
// module id = ../../../node_modules/es6-map/index.js
// module chunks = 1